/**
 * EmptyState — placeholder shown when a list or page has no data.
 */

import type { ReactNode } from 'react';

interface EmptyStateProps {
  /** Primary heading. */
  title: string;
  /** Supporting description text. */
  description?: string;
  /** Optional SVG icon element. */
  icon?: ReactNode;
  /** Optional CTA button or link. */
  action?: ReactNode;
}

const DefaultIcon = () => (
  <svg
    className="empty-state__icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
    <polyline points="13 2 13 9 20 9" />
  </svg>
);

export const EmptyState = ({
  title,
  description,
  icon,
  action,
}: EmptyStateProps) => {
  return (
    <div className="empty-state" role="status">
      {icon ?? <DefaultIcon />}
      <h3 className="empty-state__title">{title}</h3>
      {description && (
        <p className="empty-state__description">{description}</p>
      )}
      {action}
    </div>
  );
};
